export const ConfigProductos = {
   barraBusqueda: {
      criterios: ["Nombre Producto", "Codigo de Barra"],
      criteriosKeys: ["nombre", "codigoBarra"],
      criterioPrincipal: "Nombre Producto",
   },
   table: {
      title: "Productos",
      add: "Carga Producto",
      options: [
         {
            name: "Importar",
            active: true,
            class: "ft-upload",
         },
         {
            name: "Exportar",
            active: true,
            class: "ft-download",
         },
         {
            name: "Solicitar Soporte",
            active: true,
            class: "ft-shuffle",
         },
      ],
   },
};
